// tslint:disable: variable-name
import { LicitacaoOrgaoAudesp, Memorial } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';

export class MemorialAdesao extends BaseResourceModel {
  constructor(
    public id?: number,
    public quantidade?: number,
    public orgao_audesp_aderente?: LicitacaoOrgaoAudesp,
    public memorial?: Memorial,
  ) {
    super();
  }
}
